import React from 'react';
import './Header.css';


const Header = ()=> {
    return (
        <header id="home">
            <div className="container intro3">
                <div className="col-md-5 col-sm-6 ">
                    <h3>Good food choices are good investments.</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et purus a odio finibus bibendum amet leo. </p>
                    <div className="space30"></div>
                    <div className="dual-btn">
                        <a href="#Explore" className="btn page-scroll">Order Now  &nbsp; &nbsp; <span class="fa fa-shopping-basket"></span></a>  
                        <a href="#about" id="btn1" className="btn btn-default btn-border page-scroll">Learn More  &nbsp; &nbsp;<i class="fa-sharp fa-solid fa-angles-right"></i></a> 
                    </div>
                </div>
            </div>
        </header>
    )
}


export default Header;